import { fromJS } from "immutable";
import TYPE from "../../constants/type";

const initialState = fromJS({
  list: [],
  isFetching: false,
});

const sortFunc = (a, b) => a.id - b.id;

// mergeById — thay bản ghi đã có theo id, hoặc append nếu chưa có.
const mergeById = (list, item) => {
  if (!item) return list;
  const filtered = list.filter((e) => e?.id !== item.id);
  return [...filtered, item].sort(sortFunc);
};

export default function studentResearchReducer(state = initialState, action) {
  const T = TYPE.STUDENT_RESEARCH;

  switch (action.type) {
    // ---- LOADING ----
    case T.GET_ALL_STUDENT_RESEARCH_LOADING:
    case T.FILTER_STUDENT_RESEARCH_LOADING:
    case T.CREATE_STUDENT_RESEARCH_LOADING:
    case T.UPDATE_STUDENT_RESEARCH_LOADING:
    case T.STUDENT_RESEARCH_ACTION_LOADING:
    case T.DELETE_STUDENT_RESEARCH_LOADING:
      return state.merge({ isFetching: true });

    // ---- FAILURE ----
    case T.GET_ALL_STUDENT_RESEARCH_FAILURE:
    case T.FILTER_STUDENT_RESEARCH_FAILURE:
    case T.CREATE_STUDENT_RESEARCH_FAILURE:
    case T.UPDATE_STUDENT_RESEARCH_FAILURE:
    case T.STUDENT_RESEARCH_ACTION_FAILURE:
    case T.DELETE_STUDENT_RESEARCH_FAILURE:
      return state.merge({ isFetching: false });

    // ---- SUCCESS: fetch list ----
    case T.GET_ALL_STUDENT_RESEARCH_SUCCESS:
    case T.FILTER_STUDENT_RESEARCH_SUCCESS:
      return state.merge({
        isFetching: false,
        list: [...(action.payload || [])].sort(sortFunc),
      });

    // ---- SUCCESS: create ----
    case T.CREATE_STUDENT_RESEARCH_SUCCESS:
      return state.merge({
        isFetching: false,
        list: [...state.get("list"), action.payload].sort(sortFunc),
      });

    // ---- SUCCESS: update (draft) ----
    case T.UPDATE_STUDENT_RESEARCH_SUCCESS:
      return state.merge({
        isFetching: false,
        list: mergeById(state.get("list"), action.payload),
      });

    // ---- SUCCESS: action generic ----
    // Server trả về entity cập nhật (có id) → patch vào list tại chỗ.
    // Nếu không có payload, component có thể dispatch filter lại để đồng bộ.
    case T.STUDENT_RESEARCH_ACTION_SUCCESS:
      if (action.payload && typeof action.payload === "object" && action.payload.id) {
        return state.merge({
          isFetching: false,
          list: mergeById(state.get("list"), action.payload),
        });
      }
      return state.merge({ isFetching: false });

    // ---- SUCCESS: delete ----
    case T.DELETE_STUDENT_RESEARCH_SUCCESS:
      return state.merge({
        isFetching: false,
        list: state.get("list").filter((e) => e?.id !== action.id),
      });

    default:
      return state;
  }
}
